import React, { useEffect } from 'react'
import '../css/Profile.css'
import ProfileUserImage from './ProfileUserImage'
import ProfileUserDetail from './ProfileUserDetail'
import { useDispatch } from 'react-redux'
import { allapiAction } from '../../../Redux/common/action'

const Profile = () => {

  const dispatch  = useDispatch()
   
     useEffect(() => {
    // dispatch(allapiAction.vendordeshBoradData({}));
    // dispatch(allapiAction.categoryWiseSale({}));
  
    dispatch(allapiAction.getprofile());

    return () => {};
  }, []);
  return (
    <div className='text-white w-100 pt-5'>
      <ProfileUserImage />
      <ProfileUserDetail />
    </div>
  )
}

export default Profile